/* ACEWORK — Main JS */

(function() {
  'use strict';

// ── Custom Cursor ──────────────────────────────
  const cursor = document.getElementById('cursor');
  if (cursor) {
    cursor.style.pointerEvents = 'none';
    cursor.style.zIndex = '2147483647';
    document.addEventListener('mousemove', (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    document.querySelectorAll('a, button, .product-card, .pricing-card').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
    });
    document.addEventListener('mouseleave', () => { cursor.style.opacity = '0'; });
    document.addEventListener('mouseenter', () => { cursor.style.opacity = '1'; });
  }

  // ── Scroll Fade-In ─────────────────────────────
  const fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeEls.forEach(el => {
      el.style.animationPlayState = 'paused';
      io.observe(el);
    });
  }

  // ── Credit Card Interactions ───────────────────
  const ccVisual = document.querySelector('.cc-visual');
  const ccNumber = document.querySelector('.cc-number');
  const ccHolder = document.querySelector('#cc-display-holder');
  const ccMonth = document.querySelector('#cc-display-month');
  const ccYear = document.querySelector('#cc-display-year');
  const ccCvvDisplay = document.querySelector('#cc-display-cvv');
  const ccHighlight = document.querySelector('.cc-highlight');

  function updateCardNumber(val) {
    if (!ccNumber) return;
    const digits = val.replace(/\D/g, '').slice(0, 16);
    const groups = ccNumber.querySelectorAll('.cc-number__group');
    let di = 0;
    groups.forEach(group => {
      const slots = group.querySelectorAll('.cc-number__digit');
      slots.forEach(slot => {
        slot.textContent = di < digits.length ? digits[di] : '#';
        di++;
      });
    });
  }

  function setHighlight(type) {
    if (!ccHighlight) return;
    ccHighlight.className = 'cc-highlight';
    if (type) {
      ccHighlight.classList.add('active', `cc-highlight--${type}`);
    }
  }

  // Number input
  const numInput = document.getElementById('cc-number');
  if (numInput) {
    numInput.addEventListener('focus', () => setHighlight('number'));
    numInput.addEventListener('blur', () => setHighlight(null));
    numInput.addEventListener('input', (e) => {
      let v = e.target.value.replace(/\D/g, '').slice(0, 16);
      e.target.value = v.replace(/(\d{4})(?=\d)/g, '$1 ');
      updateCardNumber(v);
    });
  }

  // Holder input
  const holderInput = document.getElementById('cc-holder');
  if (holderInput) {
    holderInput.addEventListener('focus', () => setHighlight('holder'));
    holderInput.addEventListener('blur', () => setHighlight(null));
    holderInput.addEventListener('input', (e) => {
      const v = e.target.value.toUpperCase();
      e.target.value = v;
      if (ccHolder) ccHolder.textContent = v || 'NAME ON CARD';
    });
  }

  // Expiry
  const monthSel = document.getElementById('cc-month');
  const yearSel = document.getElementById('cc-year');

  if (monthSel) {
    monthSel.addEventListener('focus', () => setHighlight('expire'));
    monthSel.addEventListener('blur', () => setHighlight(null));
    monthSel.addEventListener('change', (e) => {
      if (ccMonth) ccMonth.textContent = e.target.value || 'MM';
    });
  }

  if (yearSel) {
    yearSel.addEventListener('focus', () => setHighlight('expire'));
    yearSel.addEventListener('blur', () => setHighlight(null));
    yearSel.addEventListener('change', (e) => {
      if (ccYear) ccYear.textContent = e.target.value ? e.target.value.slice(-2) : 'YY';
    });
  }

  // CVV — flip card
  const cvvInput = document.getElementById('cc-cvv');
  if (cvvInput && ccVisual) {
    cvvInput.addEventListener('focus', () => {
      ccVisual.classList.add('flipped');
      setHighlight('cvv');
    });
    cvvInput.addEventListener('blur', () => {
      ccVisual.classList.remove('flipped');
      setHighlight(null);
    });
    cvvInput.addEventListener('input', (e) => {
      const v = e.target.value.replace(/\D/g, '').slice(0, 4);
      e.target.value = v;
      if (ccCvvDisplay) ccCvvDisplay.textContent = '*'.repeat(v.length);
    });
  }

  // ── Form Validation ────────────────────────────
  const checkoutForm = document.getElementById('checkout-payment-form');
  const submitBtn = document.getElementById('cc-submit');

  function validateForm() {
    if (!checkoutForm || !submitBtn) return;
    const fields = checkoutForm.querySelectorAll('[required]');
    let allFilled = true;
    fields.forEach(f => {
      if (!f.value.trim()) allFilled = false;
    });
    submitBtn.disabled = !allFilled;
  }

if (checkoutForm) {
    checkoutForm.addEventListener('input', validateForm);
    checkoutForm.addEventListener('change', validateForm);
    validateForm();
  }
})();